/** @jsxImportSource @emotion/react */
import React, {useState, useEffect} from 'react'
import {WidgetContainer, Graphs} from 'components'
import {useDependency, useResource, useCurrentIntervalTime} from 'hooks'
import { Widgets } from './'
import { DEFAULT_WIDGET_REFRESH_MS } from 'constants'
import WbSunnyIcon from '@mui/icons-material/WbSunny'

// EA has instructed that to begin with we only provide a National forecast for solar
const DEFAULT_FILTER = {
  region: 'NZ'
}

const SolarForecastGraph = (props) => {
  const widget = Widgets['solar-forecast-graph']
  const filter = DEFAULT_FILTER
  const [intermittent, intermittentActions] = useResource('intermittent')
  
  const updateWidget = () => {
    const {region} = filter
    return Promise.all([
      region && intermittentActions.request('generation', {region, generationType: 'SOL'}),
      region && intermittentActions.request('forecast', {region, generationType: 'SOL'}),
    ])
  }
  
  const [loading, result, reload] = useDependency(updateWidget, [filter])
  const currentInterval = useCurrentIntervalTime()
  const lastUpdatedAt = intermittent.forecast?.responseAt
  const [zoom, setZoom] = useState({})
  const zoomCallback = zoom => setZoom(zoom)
  const tooltips = useState(false)

  return (
    <WidgetContainer
      widget={widget}
      title="Solar Generation Forecast (MW)"
      icon={<WbSunnyIcon/>}
      lastUpdatedAt={lastUpdatedAt}
      lastUpdatedAtAddMinutes={0}
      loading={loading}
      onWidgetRefresh={reload}
      widgetAutoRefreshMs={DEFAULT_WIDGET_REFRESH_MS}
      zoom={zoom}
      tooltips={tooltips}
      {...props}
    >
      <Graphs.IntermittentForecast
        generationType="solar"
        generationData={intermittent.generation?.data}
        forecastData={intermittent.forecast?.data}
        zoomCallback={zoomCallback}
        tooltips={tooltips}
        currentInterval={currentInterval}
      />
    </WidgetContainer>
);
}

const styles = {}

export default SolarForecastGraph